/**
 * 青山科技页面
 */
import React from 'react';
import './intro.scss';
import Partner from '../../../components/Partner/Partner';
import AboutAward from '../../../components/AboutAward/AboutAward';
import AwardHeader from '../../../components/AwardHeader/AwardHeader';

const Intro = () => {
  return (
    <div className="award-intro">
      <AwardHeader />
      <div className="about-award block-container marker" style={{ marginTop: 150 }}>
        <div className="title">关于奖项</div>
        <div className="award-content">
          <div className="award-second-content">
            <AboutAward />
          </div>
        </div>
      </div>
      <div className="block-container">
        <Partner />
      </div>
    </div>
  );
};

export default Intro;
